module.exports = __webpack_public_path__ + "img/mobileTimeline.c1d9c96d.svg";